<template>
    <BContainer class="custom-messenger-wrapper" style="padding-left: 16px;padding-right: 16px; position: fixed;">
        <div class="message-card"
          :style="status ? 'background-color: rgba(107, 203, 116, 0.9);'
          : 'background-color: rgba(238, 73, 103, 0.9);'">

          <img :src="status ? success_src : warning_src" />

          <div class="card-text" v-dompurify-html="message"></div>
        </div>
    </BContainer>
</template>

<script>
import { ref,watch } from 'vue'
export default {
    name: "custom_messenger",
    props:{
        message: String,
        status: Boolean,
    },
    setup(props){
        const warning_src = require('@/assets/icon/warning.svg')
        const success_src = require('@/assets/icon/msg_success.svg')
        const message = ref(props.message)
        watch(()=>props.message,(newVal,oldVal)=>{
            message.value = newVal
        })
        return{
            message,
            warning_src,
            success_src
        }
    }
}
</script>

<style lang="scss" scoped>

.custom-messenger-wrapper{
    display: flex;
    position: absolute;
    top: 16px;
    z-index: 1033;
    text-align: left;
    border-radius: 4px;
    width: 100%;
    .message-card{
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 8px 14px;
      border-radius: 4px;
      width: 100%;
      min-height: 56px;

      .card-text{
        padding-left: 10px;
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
        color: #FFFFFF;
        // padding: 8px 14px 8px 10px;
        text-align: left;
        align-items: center;
      }
    }
}

</style>
